import { Column } from '../objects/column';

export const LICENCE_HISTORY_MODULE = 'USER_LICENCE_HISTORY';

export const LICENCE_HISTORY_DEFAULT_COLUMNS: Column[] = [
    { label: 'created-date', field_name: 'CREATED_DATE', checked: true, order_by: 'created_date', fixed_width: true, last_updated: false },
    { label: 'action', field_name: 'ACTION', checked: true, order_by: 'is_adding', fixed_width: false, last_updated: false },
    { label: 'type', field_name: 'LICENCE_TYPE', checked: true, order_by: 'licence_type', fixed_width: false, last_updated: false },
    { label: 'licence-history-before', field_name: 'BEFORE', checked: true, order_by: '', fixed_width: true, last_updated: false },
    { label: 'licence-history-after', field_name: 'AFTER', checked: true, order_by: '', fixed_width: true, last_updated: false },
    { label: 'created-by', field_name: 'AUTHOR', checked: false, order_by: '', fixed_width: false, last_updated: false },
];

export const LICENCE_HISTORY_DEFAULT_CRITERIA = {
    limit: 25,
    page: 0,
    order: 'desc' as 'desc' | 'asc',
    order_by: 'created_date',
    licence_type__in: [] as string[],
    is_adding: '' as '' | 'true' | 'false',
    period_type: 0,
    created_date_gte: null as Date | null,
    created_date_lte: null as Date | null,
};

export type LicenceHistoryCriteria = typeof LICENCE_HISTORY_DEFAULT_CRITERIA;

export type LicenceHistoryEntry = {
    id: number;
    user: { id: number; first_name: string; last_name: string; username: string };
    created_date: string;
    is_adding: boolean;
    licence_type: string;
    reason: string | null;
    quota_before: number;
    quota_after: number;
    client: number;
};

export const LICENCE_TYPE_LABEL_KEYS: Record<string, string> = {
    OWNER: 'shared.licence-owner',
    FINANCE: 'shared.licence-finance',
    COMMERCIAL: 'shared.licence-commercial',
    BO: 'shared.licence-bo',
    CMS: 'shared.licence-cms',
    CRM: 'shared.licence-crm',
    ASSISTANT: 'shared.licence-assistant',
    HALF_LICENCE: 'shared.licence-half',
};
